import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getOpportunities = async (filters = {}) => {
  const params = new URLSearchParams();
  
  if (filters.minMargin) params.append("min_margin", filters.minMargin);
  if (filters.maxMargin) params.append("max_margin", filters.maxMargin);
  if (filters.minSaleScore) params.append("min_sale_score", filters.minSaleScore);
  if (filters.rarity) params.append("rarity", filters.rarity);
  if (filters.demand) params.append("demand", filters.demand);
  if (filters.category) params.append("category", filters.category);
  if (filters.buyPlatform) params.append("buy_platform", filters.buyPlatform);
  if (filters.sellPlatform) params.append("sell_platform", filters.sellPlatform);
  if (filters.sortBy) params.append("sort_by", filters.sortBy);
  if (filters.limit) params.append("limit", filters.limit);

  const response = await api.get(`/opportunities?${params.toString()}`);
  return response.data;
};

export const getAlerts = async (unreadOnly = false) => {
  const response = await api.get(`/alerts?unread_only=${unreadOnly}`);
  return response.data;
};

export const getPriceHistory = async (productName, platform = null) => {
  const params = platform ? `?platform=${platform}` : "";
  const response = await api.get(`/price-history/${encodeURIComponent(productName)}${params}`);
  return response.data;
};

export const scanProduct = async (url, platform = null) => {
  const response = await api.post("/scan", { url, platform });
  return response.data;
};

export const getStats = async () => {
  const response = await api.get("/stats");
  return response.data;
};

export const getCategories = async () => {
  const response = await api.get("/categories");
  return response.data;
};

export const getPlatforms = async () => {
  const response = await api.get("/platforms");
  return response.data;
};

export default api;
